import React, { useCallback, useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import TextCSS from '../Text/Styles';

const TextArea = ({
  isFocus,
  isGray,
  readOnly,
  value,
  placeholder,
  lineHeight,
  fontCSS,
  onChange,
  onFocus,
  children,
  onKeyDowntrue,
}) => {
  const textAreaRef = useRef(null);

  const handleResizeHeight = useCallback(() => {
    if (textAreaRef === null || textAreaRef.current === null) {
      return;
    }

    textAreaRef.current.style.height = `${lineHeight}px`;
    textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
  }, []);

  const handleFocus = useCallback(() => {
    if (!isFocus || value || textAreaRef === null || textAreaRef.current === null) {
      return;
    }

    textAreaRef.current.focus();
  }, []);

  useEffect(() => {
    handleResizeHeight();
  }, []);

  useEffect(() => {
    handleFocus();
  }, [isFocus]);

  const onKeyDownFunc = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <TextAreaWrapper>
      {children && children}

      <StyledTextArea
        ref={textAreaRef}
        rows={1}
        isGray={isGray}
        readOnly={readOnly}
        value={value}
        lineHeight={lineHeight}
        fontCSS={fontCSS}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={onFocus}
        onInput={handleResizeHeight}
        onKeyDown={onKeyDowntrue && onKeyDownFunc}
        // onKeyDown={event => {
        //   // 엔터키를 눌렀을 때 기본 동작을 막음
        //   if (event.key === 'Enter') {
        //     event.preventDefault();
        //   }
        // }}
      />
    </TextAreaWrapper>
  );
};

TextArea.propTypes = {
  isFocus: PropTypes.bool,
  isGray: PropTypes.bool,
  readOnly: PropTypes.bool,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  lineHeight: PropTypes.number,
  fontCSS: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.func])),
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  children: PropTypes.node,
};

TextArea.defaultProps = {
  isFocus: false,
  isGray: false,
  readOnly: false,
  lineHeight: 28,
  fontCSS: TextCSS.BodyB,
  onFocus: () => {},
  children: undefined,
};

const TextAreaWrapper = styled.div`
  position: relative;
  width: 100%;

  display: flex;
`;

const StyledTextArea = styled.textarea`
  ${({ fontCSS }) => css`
    ${fontCSS}
  `};

  color: ${({ isGray, theme }) => isGray && theme.colors.ui_on_3};

  display: flex;
  resize: none;
  overflow: hidden;
  outline: none;
  border: none;

  background-color: transparent;
  width: 100%;
  padding: 0px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.ui_on_4};
  }

  ${({ lineHeight, readOnly, theme }) => css`
    min-height: ${lineHeight}px;
    line-height: ${lineHeight}px;
    caret-color: ${theme.colors.ui_on_1};
    cursor: ${readOnly ? 'pointer' : 'text'};
  `}
`;

export default TextArea;
